import { useEffect, useState } from "react";
import { useRuntimeConstants } from "../context/runtimeConstants/RuntimeConstantsContext";
import { useFeaturesReady } from "../context/featuresReady/FeaturesReadyContext";
import { getFeature } from "../utils/features";
import { getLoyaltySDK } from "../api/loyaltySdk";
import {
  FEATURE_FLAGS,
  NEW_IN_CATEGORY_IDS,
  LOYALTY_CONSENT_STATUS,
} from "../constants";

export const useNewInBoxConditions = () => {
  const [shouldShow, setShouldShow] = useState(false);
  const { referrerData } = useRuntimeConstants();
  const { areFeaturesReady } = useFeaturesReady();

  const cid = referrerData?.cid;
  const isFromNewInPage = [
    NEW_IN_CATEGORY_IDS.WOMEN,
    NEW_IN_CATEGORY_IDS.MEN,
  ].includes(cid);

  useEffect(() => {
    if (!areFeaturesReady) {
      return;
    }

    if (!isFromNewInPage) {
      setShouldShow(false);
      return;
    }

    const checkEligibilityAndExperiment = async () => {
      try {
        const loyaltySdk = await getLoyaltySDK();

        if (!loyaltySdk.isLoyaltyAvailable()) {
          setShouldShow(false);
          return;
        }

        let isInExperiment = true;

        const customerTierId = await loyaltySdk.getCustomerTierId();

        if (customerTierId && loyaltySdk.getCustomerDetails) {
          const customerDetails = await loyaltySdk.getCustomerDetails();

          isInExperiment =
            customerDetails?.consentStatus !== LOYALTY_CONSENT_STATUS.OPTED_IN;
        }

        if (!isInExperiment) {
          setShouldShow(false);
          return;
        }

        const { isEnabled, getVariables } = getFeature(
          FEATURE_FLAGS.LOYALTY_NEW_IN_TODAY_LOCK_PRODUCT
        );
        const isExperimentEnabled =
          isEnabled() && getVariables()?.bucket === "v2";

        setShouldShow(isExperimentEnabled);
      } catch {
        setShouldShow(false);
      }
    };

    checkEligibilityAndExperiment();
  }, [areFeaturesReady, isFromNewInPage]);

  return shouldShow;
};
